import { createReducer, updateItemInArray, updateObject } from 'helpers/ReducerUtil'
import {
  MISSION_PROFILE_ADD,
  MISSION_PROFILE_REMOVE,
  MISSION_PROFILE_UPDATE,
  POWER_ON_ADD,
  POWER_ON_REMOVE,
  POWER_ON_UPDATE,
  POWER_OFF_ADD,
  POWER_OFF_REMOVE,
  POWER_OFF_UPDATE
} from './constants'

const POWER_ON = 'powerOn'
const POWER_OFF = 'powerOff'

const breakdownAdd = (type, values, mpIndex) => {
    const addObj = {
      tA: '',
      tJ: '',
      tPercent: '',
      tH: ''
    }
    return values.map((x, i) => {
      if (i === mpIndex) {
        return !x[type] ? 
        {
          ...x,
          [type]: [
            addObj
          ]
        }
        : {
          ...x,
          [type]: [
            ...x[type],
            addObj
          ]
        }
      } else {
        return x
      }
    })
  }

const breakdownRemove = (type, values, mpIndex, index) => 
  values.map((x, i) => {
    if (i === mpIndex) {
      return {
        ...x,
        [type]: x[type].filter((_, poIndex) => poIndex !== index)
      }
    } else {
      return x
    }
  })

const breakdownUpdate = (type, values, mpIndex, index, value, element) => 
  values.map((x, i) => {
    if (i === mpIndex) {
      return {
        ...x,
        [type]: x[type].map((po, poIndex) => {
          if (poIndex === index) {
            return {
              ...po,
              [element]: value
            }
          } else {
            return po
          }
        })
      }
    } else {
      return x
    }
  })


const missionProfileAdd = (values) => 
  [
    ...values, 
    { 
      vehicleType: '', 
      serviceLife: '', 
      powerOnHours: '', 
      powerOffHours: '',
      mileage: '',
      powerOnOffCycles: '',
      powerOn: [],
      powerOff: []
    }
  ]

const missionProfileRemove = (values, { index }) => values.filter(
  (value, currentIndex) => index !== currentIndex
)

const missionProfileUpdate = (values, { value, index, element }) => updateItemInArray(
  values,
  index,
  oldValue => updateObject(oldValue, { ...oldValue, [element]: value })
)

const powerOnAdd = (values, { mpIndex }) => breakdownAdd(POWER_ON, values, mpIndex)
const powerOffAdd = (values, { mpIndex }) => breakdownAdd(POWER_OFF, values, mpIndex)


const powerOnRemove = (values, { mpIndex, index }) => breakdownRemove(POWER_ON, values, mpIndex, index)
const powerOffRemove = (values, { mpIndex, index }) => breakdownRemove(POWER_OFF, values, mpIndex, index)

const powerOnUpdate = (values, { mpIndex, index, value, element }) => breakdownUpdate(POWER_ON, values, mpIndex, index, value, element)
const powerOffUpdate = (values, { mpIndex, index, value, element }) => breakdownUpdate(POWER_OFF, values, mpIndex, index, value, element)

const missionProfileInputReducer = createReducer([], {
  [MISSION_PROFILE_ADD]: missionProfileAdd,
  [MISSION_PROFILE_REMOVE]: missionProfileRemove,
  [MISSION_PROFILE_UPDATE]: missionProfileUpdate,
  [POWER_ON_ADD]: powerOnAdd,
  [POWER_ON_REMOVE]: powerOnRemove,
  [POWER_ON_UPDATE]: powerOnUpdate,
  [POWER_OFF_ADD]: powerOffAdd,
  [POWER_OFF_REMOVE]: powerOffRemove,
  [POWER_OFF_UPDATE]: powerOffUpdate
})

export default missionProfileInputReducer
